//APP CONSTANTS
export const AUTH_TOKEN = 'AUTH_TOKEN';
export const LOGIN_DATA = 'LOGIN_DATA';